import veeva from './veeva.svg';
import iqviaoce from './iqvia-oce.svg';
import marketo from './marketo.svg';
import salesforce from './salesforce.svg';
import adLib from './adLib.svg';

export const connectedApp = {
    'veeva': veeva,
    'iqvia oce': iqviaoce,
    'marketo': marketo,
    'salesforce': salesforce,
    'adlib dsp advertising': adLib,
};